import { createFileRoute } from "@tanstack/react-router";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { meApi } from "@/api/me";
import { authApi } from "@/api/auth";
import { Trash2 } from "lucide-react";

export const Route = createFileRoute("/app/account/sessions")({
  component: SessionsTab,
});

function SessionsTab() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["sessions"], queryFn: meApi.sessions });

  const revoke = useMutation({
    mutationFn: (sid: string) => meApi.revokeSession(sid),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["sessions"] }),
  });

  const revokeAll = useMutation({
    mutationFn: () => authApi.logoutAll(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["sessions"] }),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <button onClick={() => { if (confirm("Sign out of every device?")) revokeAll.mutate(); }} className="btn-secondary">
          Sign out everywhere
        </button>
      </div>

      <div className="card overflow-x-auto p-0">
        <table className="w-full text-sm">
          <thead className="bg-cream text-left text-xs uppercase tracking-wide text-ink/55">
            <tr>
              <th className="px-4 py-3">Device</th>
              <th className="px-4 py-3">IP</th>
              <th className="px-4 py-3">Country</th>
              <th className="px-4 py-3">Last used</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? <tr><td colSpan={5} className="px-4 py-6 text-ink/55">Loading…</td></tr>
            : data?.length ? data.map((s) => (
              <tr key={s.id} className="border-t border-ink/8">
                <td className="px-4 py-3">
                  <div className="line-clamp-1 max-w-md">{s.user_agent ?? "Unknown device"}</div>
                  {s.current && <span className="mt-0.5 inline-block rounded bg-primary-100 px-1.5 py-0.5 text-xs font-medium text-primary-700">This session</span>}
                </td>
                <td className="px-4 py-3 font-mono text-xs">{s.ip ?? "—"}</td>
                <td className="px-4 py-3 text-ink/55">{s.country ?? "—"}</td>
                <td className="px-4 py-3 text-ink/55">{new Date(s.issued_at).toLocaleString()}</td>
                <td className="px-4 py-3 text-right">
                  <button
                    onClick={() => { if (!s.current && confirm("Revoke this session?")) revoke.mutate(s.id); }}
                    disabled={s.current}
                    className="text-red-600 hover:text-red-800 disabled:cursor-not-allowed disabled:text-ink/35"
                  >
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            )) : <tr><td colSpan={5} className="px-4 py-6 text-ink/55">No active sessions.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
